import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import Icon, { ICON_PROPTYPES } from '../../foundations/icon/Icon'
import debounce from 'lodash/debounce'

const DEFAULT_SIZE = 32

const switchIcon = (fn) => debounce(() => fn(), 100)

const HarveyIcon = ({ harveyImg, dentImg, size, face, ...props}) => {
	const [img, setImg] = React.useState(harveyImg);

	useEffect(() => {
		switchIcon(() => {
            setImg(face === 'harvey' ? harveyImg : dentImg)
        })()
	}, [face])

    return <Icon img={img} size={size}/>
}

HarveyIcon.propTypes = {
	harveyImg: ICON_PROPTYPES.img,
	dentImg: ICON_PROPTYPES.img,
	face: PropTypes.oneOf(['harvey', 'dent']),
	size: PropTypes.string
}

HarveyIcon.defaultProps = {
	size: DEFAULT_SIZE,
	face: 'harvey'
}


export default HarveyIcon;
